import { ComponentProps } from 'react';

function RocketLaunchIcon(props: ComponentProps<'svg'>) {
  return (
    <svg
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M3.33333 10.8327C2.64167 10.8327 2.01667 11.116 1.56667 11.566C0.583333 12.5493 0 16.666 0 16.666C0 16.666 4.11667 16.0827 5.1 15.0993C5.55 14.6493 5.83333 14.0243 5.83333 13.3327C5.83333 11.9493 4.71667 10.8327 3.33333 10.8327ZM3.925 13.9243C3.69167 14.1577 2.11667 14.5577 2.11667 14.5577C2.11667 14.5577 2.50833 12.991 2.75 12.7493C2.89167 12.591 3.1 12.4993 3.33333 12.4993C3.79167 12.4993 4.16667 12.8743 4.16667 13.3327C4.16667 13.566 4.075 13.7743 3.925 13.9243ZM12.85 9.70767C18.15 4.40767 16.3833 0.282667 16.3833 0.282667C16.3833 0.282667 12.2583 -1.484 6.95833 3.816L4.88333 3.39933C4.34167 3.291 3.775 3.466 3.375 3.85767L0 7.241L4.16667 9.02433L7.64167 12.4993L9.425 16.666L12.8 13.291C13.1917 12.8993 13.3667 12.3327 13.2583 11.7827L12.85 9.70767ZM4.50833 7.35767L2.91667 6.67433L4.55833 5.03267L5.75833 5.27433C5.28333 5.966 4.85833 6.691 4.50833 7.35767ZM9.99167 13.7493L9.30833 12.1577C9.975 11.8077 10.7 11.3827 11.3833 10.9077L11.625 12.1077L9.99167 13.7493ZM11.6667 8.53267C10.5667 9.63267 8.85 10.5327 8.3 10.8077L5.85833 8.366C6.125 7.82433 7.025 6.10767 8.13333 4.99933C12.0333 1.09933 14.9917 1.67433 14.9917 1.67433C14.9917 1.67433 15.5667 4.63267 11.6667 8.53267ZM10.8333 7.49933C11.75 7.49933 12.5 6.74933 12.5 5.83267C12.5 4.916 11.75 4.166 10.8333 4.166C9.91667 4.166 9.16667 4.916 9.16667 5.83267C9.16667 6.74933 9.91667 7.49933 10.8333 7.49933Z'
        fill='currentColor'
      />
    </svg>
  );
}

export { RocketLaunchIcon };
